import {
  BaseSyntheticEvent,
  DragEvent,
  PropsWithChildren,
  useContext,
} from 'react';

import { useAppDispatch } from '../../../../../../store/hooks';
import { ApkInfoModel } from '../../../../models/apk-info.model';
import { uploadApkFiles } from '../../../../thunks/upload-apk-files.thunk';
import { SnackBarContext } from '../../../snack-bar-context/SnackBarContext';
import { DragAndDropProps } from '../../models/drag-and-drop.model';

export const useHandleApkFileDrop = (
  callbackFunction: (file: File) => void,
  props: PropsWithChildren<DragAndDropProps>,
  handleDragLeave: (event: BaseSyntheticEvent<object, any, any>) => void
): ((event: DragEvent<HTMLDivElement>) => void) => {
  const dispatch = useAppDispatch();
  const snackBarCtx = useContext(SnackBarContext);

  const onError = (): void => {
    snackBarCtx?.changeSeverity?.('error');
    snackBarCtx?.changeMessage(
      'Something went wrong while uploading the file!'
    );
    snackBarCtx?.isOpen?.(true);
  };

  const onSuccess = (): void => {
    snackBarCtx?.changeSeverity?.('success');
    snackBarCtx?.changeMessage('File upload success!');
    snackBarCtx?.isOpen?.(true);
  };

  return async (event: DragEvent<HTMLDivElement>): Promise<void> => {
    handleDragLeave(event);
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const dataTransferFiles: File[] = Array.from(event.dataTransfer.files);
      for (const element of dataTransferFiles) {
        await dispatch(
          uploadApkFiles({
            file: element,
            onFileUploadCallback: callbackFunction,
            onFileRequestCallback: props.uploadHandler,
            fileType: props.fileType,
            splitIntoChunks: !!props.splitIntoChunks,
            onError,
            onSuccess,
            appId: props.featureId as number,
            apkInfo: props.apkInfo as ApkInfoModel,
          })
        );
      }
    }
  };
};
